<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.label) {
        <label for="form-element-{{ formField.id }}" (click)="selectElement?.focus()" class="form-element-label">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }

    @if (isProductMetaDataHidden) {
        @if (selectedValue) {
            <div class="form-control">
                <div class="d-flex align-items-center">
                    <img alt="" class="product-image" [src]="selectedValue.image" />
                    <div>
                        <span class="text-break">{{ selectedValue.name | truncate: 50 }}</span>

                        @if (selectedValue.categoryName) {
                            <span class="text-break">, {{ selectedValue.categoryName }}</span>
                        }
                        @if (selectedValue.ean) {
                            <span class="text-light">, {{ selectedValue.ean }}</span>
                        }
                    </div>
                </div>
                <span class="clear-button" (click)="cleanSelectedValue()">×</span>
            </div>
        }
        <ng-select
            [hidden]="selectedValue"
            #select
            id="form-element-{{ formField.id }}"
            bindLabel="name"
            dropdownPosition="bottom"
            name="product"
            class="select-control"
            appSelectAccessibility
            [inputAriaLabelAttribute]="labelText || formField.placeholder || ('Product name' | translate)"
            appFocus
            [appAutoFocus]="formField.isNeedToFocus"
            [focusableSelectElement]="selectElement"
            [(ngModel)]="selectedValue"
            [items]="products"
            [placeholder]="formField.placeholder || ('Product name' | translate)"
            [loading]="loadingProducts"
            [notFoundText]="notFoundText"
            [loadingText]="'Loading...' | translate"
            [searchFn]="customSearchFn"
            (search)="onSearch($event)"
            (change)="onSelect()"
            (clear)="onClear()"
            (blur)="onBlur()"
            [required]="formField.isRequired">
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="searchTerm">
                <div class="d-flex align-items-center">
                    <img alt="" class="product-image" [src]="item.image" />
                    <div>
                        <span class="product-name">{{ item.name }}</span>
                        <div class="product-description text-light">{{ item.description }}</div>
                        <!--                        <strong class="product-price">{{ item.price }}</strong>-->
                    </div>
                </div>
            </ng-template>
        </ng-select>
    } @else {
        @if (isInitValue && selectedValue) {
            <div class="form-control h-39px d-flex align-items-center">
                <span class="truncate">{{ selectedValue }}</span>
                <span class="clear-button" (click)="cleanSelectedValue()">×</span>
            </div>
        }
        <ng-select
            [hidden]="isInitValue && selectedValue"
            #select
            bindLabel="name"
            dropdownPosition="bottom"
            name="product"
            class="select-control"
            appSelectAccessibility
            [inputAriaLabelAttribute]="labelText || formField.placeholder || ('Product name' | translate)"
            [(ngModel)]="selectedValue"
            [items]="products"
            [placeholder]="placeholderName"
            [loading]="loadingProducts"
            [notFoundText]="notFoundText"
            [loadingText]="'Loading...' | translate"
            [searchFn]="customSearchFn"
            (search)="onSearch($event)"
            (change)="onSelect()"
            (clear)="onClear()"
            (blur)="onBlur()"
            [required]="formField.isRequired">
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="searchTerm">
                <div class="text-break">
                    <span class="product-name">{{ item.name }}</span>
                    @if (item.description) {
                        <span class="text-light">, {{ item.description }}</span>
                    }
                    @if (item.price) {
                        <span class="text-light">, {{ item.price }}</span>
                    }
                    <span class="text-light">
                        @if (item.categoryName) {
                            {{ '(Category:' | translate }}&nbsp;{{ item.categoryName }};
                        } @else {
                            (
                        }
                    </span>
                    <span class="text-light">{{ 'EAN:' | translate }}&nbsp;{{ item.ean }})</span>
                </div>
            </ng-template>
        </ng-select>
    }
</div>
